import API from '../plugins/http';
//import Utils from '../plugins/util';
const coupons = {
  namespaced: true,
  state: {
    items: [],
    couponscode:[],
    item: {},
    totalRows: 0,
    
    isLoading: false,
    errorMessage: '',
    successMessage: '',
    isError: false,
    refresh: false,
    totalRowsUsage: 0,
    isLoadingUsage: false,
    isErrorUsage: false,
  },
  getters: {
  },
  actions: {
    async actionGetCoupontsFilter({ commit }, props) {
      commit('setLoading', true);
    
      try {
        const queryParams = new URLSearchParams({
          page: props.page,
          limit: props.limit,
          order_by: props.order,
          sort:props.sort,
          ...(props.is_active !== null && { is_active: props.is_active }),
          ...(props.availability !== null && { availability: props.availability }),
          ...(props.search !== null && { search: props.search }),
        });
    
        const response = await API.get(`coupon?${queryParams.toString()}`);
        commit('setRows', response.data?.data?.count);
        commit('setItems', response.data?.data?.rows);
      } catch (error) {
        return error;
      } finally {
        commit('setLoading', false);
      }
    },    
    async fetchCouponts({ commit }, props) {
      try {
        commit('setError', false);
        commit('setLoading', true);
        let URL = `coupon?page=${props.page}&limit=${props.limit}`; 
        const response = await API.get(URL);
        commit('setItems', response.data.data.rows);
        commit('setRows', response.data.data.count);
        commit('setLoading', false);
      } catch (error) {
        commit('setLoading', false);
        commit('setError', true);
      }
    },

    async fetchCouponCodeId({ commit }, props) {      
      try {
        commit('setError', false);
        commit('setLoading', true);
        const queryParams = new URLSearchParams({
          page: props.page,
          limit: props.limit,
          ...(props.search ? { search: props.search } : {})
        });
        let URL = `coupon/coupon-code-detail/${props.id}?${queryParams.toString()}`; 
        const response = await API.get(URL);
        commit('setCouponCode', response.data.data.rows);
        commit('setRows', response.data.data.count);
        commit('setLoading', false);
      } catch (error) {
        commit('setCouponCode', []);
        commit('setLoading', false);
        commit('setError', true);
      }
    },

    async downloadCSVCoupon({commit}, id) {
      commit('setLoading', true);
      try {
        const response = await API.get(`coupon/export/${id}`, {
          responseType: "blob", 
        });
        const url = URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `coupon_${id}.csv`);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Gagal mengunduh CSV:", error);
       // alert("Terjadi kesalahan saat mengunduh file.");
      }
    },
    async couponsPost({ commit }, payload) {
      commit('setErrorMessage', null);
      commit('setSuccessMessage', null);
      commit('setError', false);
      commit('setLoading', true);
      try {
        const response = await API.post(`coupon/create`, payload);
        if (response.status == 200) {
          commit('setSuccessMessage', 'Success Created');
          commit('setLoading', false);
        }
        commit('setLoading', false);
      } catch (error) {
        const response = error.response;
        let errMsg = 'Error, please try again';
        if (response.status == 404) errMsg = response.statusText;
        if (response.status == 400) {
          errMsg = response.data.message;
        }
        if (response.status == 500) {
          errMsg = response.data.data.message ?? response.statusText;
        }
        commit('setError', true);
        commit('setErrorMessage', errMsg);
        commit('setLoading', false);
      }
    },
  async couponsUpdate({ commit },  payload) {
    commit('setErrorMessage', null);
    commit('setSuccessMessage', null);
    commit('setError', false);
    commit('setLoading', true);
    try {
      const response = await API.put(
        `coupon/update/${payload.id}`,
        payload,
      );
      if (response.status == 200) {
        commit('setSuccessMessage', 'Updated Success');
        commit('setLoading', false);
      }
      commit('setLoading', false);
    } catch (error) {
      let errMsg = 'Error, please try again';
      if (response.status == 400) {
        errMsg = response.data.message;
      }
      const response = error.response;
      commit('setError', true);
      commit('setErrorMessage', errMsg);
      commit('setLoading', false);
    }
  },
    async fetchCouponDetailByid({ commit }, id) {
      try {
        commit('setLoading', true);
        const response = await API.get(`coupon/detail/${id}`);
        commit('setItems', response.data.data);
        commit('setItem', response.data.data);
        // commit('setRows', 1);
        commit('setLoading', false);
      } catch (error) {
        commit('setLoading', false);
        commit('setError', true);
      }
    },
},
  mutations: {
    setItems(state, item) {
      state.items = item;
    },
    setCouponCode(state,item) {
      state.couponscode = item
    },
    setItem(state, item) {
      state.item = item;
    },
    setRows(state, data) {
      state.totalRows = data;
    },
    setLoading(state, data) {
      state.isLoading = data;
    },
    setSuccessMessage(state, data) {
      state.successMessage = data;
    },
    setErrorMessage(state, data) {
      state.errorMessage = data;
    },
    setError(state, data) {
      state.isError = data;
    },
    setRefresh(state, data) {
      state.refresh = data;
    },
  },
};

export default coupons;
